import { EmailsBehaviourDto } from '../../../interfaces/dtos/EmailsBehaviourDto';
import { EmailsDto } from '../../../interfaces/dtos/EmailsDto';
import { Emails } from '../../../interfaces/Emails';

export default function transformEmails(dto: EmailsDto, behaviours: EmailsBehaviourDto): Emails {
  return {
    home: dto.emailHome,
    work: dto.emailWork,
    homeConfirm: dto.emailHome,
    workConfirm: dto.emailWork,
    behaviours: {
      isEmailHomeReadOnly: behaviours.isEmailHomeReadOnly,
      isEmailHomeRequired: behaviours.isEmailHomeRequired,
      isEmailHomeValidated: behaviours.isEmailHomeValidated,
      isEmailWorkReadOnly: behaviours.isEmailWorkReadOnly,
      isEmailWorkRequired: behaviours.isEmailWorkRequired,
      isEmailWorkValidated: behaviours.isEmailWorkValidated,
      showConfirmationEmailFields: behaviours.showConfirmationEmailFields,
      showEmailValidationSection: behaviours.showEmailValidationSection,
      showSection: behaviours.showSection,
      showWorkEmail: behaviours.showWorkEmail,
    },
  };
}
